import { ComponentFields } from 'types/content';
import styles from './CheckAudio.module.scss';
import Image from 'next/image';
import { useState } from 'react';
import AudioPlayer from './media/AudioPlayer';
import { parseAudio } from 'lib/content-parsers/componentParsers';
import AudioIcon from './icons/AudioIcon';
import CaretIcon from './icons/CaretIcon';
import UILink from './ui/UILink';

import { type Elements } from '@kontent-ai/delivery-sdk';
import { Audio } from 'kontent-ai/content-types';

const CheckAudio = ({ data, onContinue }: ComponentFields) => {
  const [playAudio, setPlayAudio] = useState<boolean>(false);

  const testAudio = data.elements
    .testAudio as Elements.LinkedItemsElement<Audio>;
  const audio = parseAudio(testAudio.linkedItems[0]);

  return (
    <div className={styles.audioPage}>
      <section className={styles.audioContainer}>
        <Image
          className={styles.iconPlay}
          src="/bubble_play.svg"
          alt="Play Icon"
          width={122}
          height={122}
        />
        <h2>A quick thing before we start...</h2>
        <p className={styles.description}>{data.elements.description.value}</p>

        <div className={styles.buttonContainer}>
          <button
            className="button secondary"
            disabled={playAudio}
            onClick={() => {
              setPlayAudio(true);
            }}
          >
            <AudioIcon />
            <span>Test Audio</span>
          </button>
          <button
            className="button primary"
            data-testid="check-audio-get-started"
            onClick={() => {
              onContinue();
            }}
          >
            <span>Get Started</span>
            <CaretIcon direction="right" color="white" size="large" />
          </button>
        </div>

        <div className={styles.alreadyMember}>
          <p>
            Already a member?{' '}
            <UILink
              textType="body"
              size="large"
              label="Log in"
              href="/auth/login"
            />{' '}
            and pick up where you left off.
          </p>
        </div>

        {playAudio && (
          <AudioPlayer
            source={audio.mp3File.url}
            track={audio.closedCaption?.url}
            onContinue={onContinue}
            onAudioEnd={() => setPlayAudio(false)}
          />
        )}
      </section>
    </div>
  );
};

export default CheckAudio;
